import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "form"
}
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-4" }
const _hoisted_5 = { class: "col-5" }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = { class: "col-4" }
const _hoisted_9 = { class: "col-4" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = { class: "col-3" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-3" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = {
  key: 0,
  class: "row"
}
const _hoisted_20 = { class: "col-3" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = {
  key: 1,
  class: "row"
}
const _hoisted_23 = { class: "col-3" }
const _hoisted_24 = { class: "col" }
const _hoisted_25 = {
  key: 2,
  class: "row"
}
const _hoisted_26 = { class: "col-3" }
const _hoisted_27 = { class: "col" }
const _hoisted_28 = {
  key: 3,
  class: "row"
}
const _hoisted_29 = { class: "col-3" }
const _hoisted_30 = { class: "col" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-save fw-bold me-8",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_v_loader = _resolveComponent("v-loader")!
  const _component_v_form_group_input_text = _resolveComponent("v-form-group-input-text")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form_group_select = _resolveComponent("v-form-group-select")!
  const _component_v_form_group_input_date = _resolveComponent("v-form-group-input-date")!
  const _component_modal_body = _resolveComponent("modal-body")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_modal_footer = _resolveComponent("modal-footer")!
  const _component_v_modal = _resolveComponent("v-modal")!

  return (_openBlock(), _createBlock(_component_v_modal, {
    size: "xl",
    "class-name": "modal-fullscreen-lg-down"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_modal_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_modal_title, { as: "h4" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Paciente')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_modal_body, null, {
        default: _withCtx(() => [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_v_loader, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("fieldset", _hoisted_2, [
                  _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Datos básicos')), 1),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.name,
                        label: _ctx.$t('Nombre'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.name,
                        autocomplete: "off",
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.name = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.surname,
                        label: _ctx.$t('Apellidos'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.surname,
                        autocomplete: "off",
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.surname = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_v_form_group_select, {
                        label: _ctx.$t('Género'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.genre
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            class: _normalizeClass({'is-invalid': !!_ctx.errors.genre}),
                            options: _ctx.formsSettings.accepted_genre_options,
                            reduce: returnValue => returnValue.key,
                            "select-on-key-codes": [188, 13],
                            clearable: false,
                            modelValue: _ctx.genre,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.genre) = $event))
                          }, {
                            "no-options": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                            ]),
                            _: 1
                          }, 8, ["class", "options", "reduce", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_v_form_group_select, {
                        label: _ctx.$t('Tipo documento'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.identityDocType
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            class: _normalizeClass({'is-invalid': !!_ctx.errors.identityDocType}),
                            options: _ctx.formsSettings.accepted_identification_document_types,
                            reduce: returnValue => returnValue.key,
                            "select-on-key-codes": [188, 13],
                            clearable: false,
                            modelValue: _ctx.identityDocType,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.identityDocType) = $event))
                          }, {
                            "no-options": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                            ]),
                            _: 1
                          }, 8, ["class", "options", "reduce", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.nif,
                        label: _ctx.$t('Nº documento identidad'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.nif,
                        autocomplete: "off",
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.nif = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_v_form_group_input_date, {
                        label: _ctx.$t('Fecha de nacimiento'),
                        value: _ctx.bornDate,
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.bornDate,
                        autocomplete: "off",
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.bornDate = $event))
                      }, null, 8, ["label", "value", "yup-errors-variable"])
                    ])
                  ])
                ]),
                _createElementVNode("fieldset", _hoisted_10, [
                  _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Contacto')), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_v_form_group_input_text, {
                        type: "email",
                        value: _ctx.email,
                        label: _ctx.$t('Correo electrónico'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.email,
                        autocomplete: "off",
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.email = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_v_form_group_select, {
                        label: _ctx.$t('Prefijo tel.'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.phoneNumberPrefix
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            class: _normalizeClass({'is-invalid': !!_ctx.errors.phoneNumberPrefix}),
                            options: _ctx.formsSettings.valid_phone_number_prefix_options,
                            reduce: returnValue => returnValue.key,
                            "select-on-key-codes": [188, 13],
                            clearable: false,
                            modelValue: _ctx.phoneNumberPrefix,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.phoneNumberPrefix) = $event))
                          }, {
                            "no-options": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                            ]),
                            _: 1
                          }, 8, ["class", "options", "reduce", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.phoneNumber,
                        label: _ctx.$t('Teléfono'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.phoneNumber,
                        autocomplete: "off",
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.phoneNumber = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ])
                  ])
                ]),
                _createElementVNode("fieldset", _hoisted_15, [
                  _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Otros teléfonos')), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_v_form_group_select, {
                        label: _ctx.$t('Prefijo tel.'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.auxPhoneNumberPrefixOne
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            class: _normalizeClass({'is-invalid': !!_ctx.errors.auxPhoneNumberPrefixOne}),
                            options: _ctx.formsSettings.valid_phone_number_prefix_options,
                            reduce: returnValue => returnValue.key,
                            "select-on-key-codes": [188, 13],
                            clearable: true,
                            modelValue: _ctx.auxPhoneNumberPrefixOne,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.auxPhoneNumberPrefixOne) = $event))
                          }, {
                            "no-options": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                            ]),
                            _: 1
                          }, 8, ["class", "options", "reduce", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.auxPhoneNumberOne,
                        label: _ctx.$t('Teléfono'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.auxPhoneNumberOne,
                        autocomplete: "off",
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (_ctx.auxPhoneNumberOne = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ])
                  ]),
                  (_ctx.auxPhoneNumberPrefixOne && _ctx.auxPhoneNumberOne ||
             _ctx.auxPhoneNumberPrefixTwo || _ctx.auxPhoneNumberTwo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_v_form_group_select, {
                            label: _ctx.$t('Prefijo tel.'),
                            class: "mb-24",
                            "yup-errors-variable": _ctx.errors.auxPhoneNumberPrefixTwo
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                class: _normalizeClass({'is-invalid': !!_ctx.errors.auxPhoneNumberPrefixTwo}),
                                options: _ctx.formsSettings.valid_phone_number_prefix_options,
                                reduce: returnValue => returnValue.key,
                                "select-on-key-codes": [188, 13],
                                clearable: true,
                                modelValue: _ctx.auxPhoneNumberPrefixTwo,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.auxPhoneNumberPrefixTwo) = $event))
                              }, {
                                "no-options": _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                                ]),
                                _: 1
                              }, 8, ["class", "options", "reduce", "modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label", "yup-errors-variable"])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_v_form_group_input_text, {
                            value: _ctx.auxPhoneNumberTwo,
                            label: _ctx.$t('Teléfono'),
                            class: "mb-24",
                            "yup-errors-variable": _ctx.errors.auxPhoneNumberTwo,
                            autocomplete: "off",
                            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (_ctx.auxPhoneNumberTwo = $event))
                          }, null, 8, ["value", "label", "yup-errors-variable"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.auxPhoneNumberPrefixTwo && _ctx.auxPhoneNumberTwo ||
             _ctx.auxPhoneNumberPrefixThree || _ctx.auxPhoneNumberThree)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_v_form_group_select, {
                            label: _ctx.$t('Prefijo tel.'),
                            class: "mb-24",
                            "yup-errors-variable": _ctx.errors.auxPhoneNumberPrefixThree
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                class: _normalizeClass({'is-invalid': !!_ctx.errors.auxPhoneNumberPrefixThree}),
                                options: _ctx.formsSettings.valid_phone_number_prefix_options,
                                reduce: returnValue => returnValue.key,
                                "select-on-key-codes": [188, 13],
                                clearable: true,
                                modelValue: _ctx.auxPhoneNumberPrefixThree,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.auxPhoneNumberPrefixThree) = $event))
                              }, {
                                "no-options": _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                                ]),
                                _: 1
                              }, 8, ["class", "options", "reduce", "modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label", "yup-errors-variable"])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_v_form_group_input_text, {
                            value: _ctx.auxPhoneNumberThree,
                            label: _ctx.$t('Teléfono'),
                            class: "mb-24",
                            "yup-errors-variable": _ctx.errors.auxPhoneNumberThree,
                            autocomplete: "off",
                            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (_ctx.auxPhoneNumberThree = $event))
                          }, null, 8, ["value", "label", "yup-errors-variable"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.auxPhoneNumberPrefixThree && _ctx.auxPhoneNumberThree ||
             _ctx.auxPhoneNumberPrefixFour || _ctx.auxPhoneNumberFour)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_v_form_group_select, {
                            label: _ctx.$t('Prefijo tel.'),
                            class: "mb-24",
                            "yup-errors-variable": _ctx.errors.auxPhoneNumberPrefixFour
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                class: _normalizeClass({'is-invalid': !!_ctx.errors.auxPhoneNumberPrefixFour}),
                                options: _ctx.formsSettings.valid_phone_number_prefix_options,
                                reduce: returnValue => returnValue.key,
                                "select-on-key-codes": [188, 13],
                                clearable: true,
                                modelValue: _ctx.auxPhoneNumberPrefixFour,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.auxPhoneNumberPrefixFour) = $event))
                              }, {
                                "no-options": _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                                ]),
                                _: 1
                              }, 8, ["class", "options", "reduce", "modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label", "yup-errors-variable"])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_v_form_group_input_text, {
                            value: _ctx.auxPhoneNumberFour,
                            label: _ctx.$t('Teléfono'),
                            class: "mb-24",
                            "yup-errors-variable": _ctx.errors.auxPhoneNumberFour,
                            autocomplete: "off",
                            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => (_ctx.auxPhoneNumberFour = $event))
                          }, null, 8, ["value", "label", "yup-errors-variable"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.auxPhoneNumberPrefixFour && _ctx.auxPhoneNumberFour ||
             _ctx.auxPhoneNumberPrefixFive || _ctx.auxPhoneNumberFive)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_v_form_group_select, {
                            label: _ctx.$t('Prefijo tel.'),
                            class: "mb-24",
                            "yup-errors-variable": _ctx.errors.auxPhoneNumberPrefixFive
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                class: _normalizeClass({'is-invalid': !!_ctx.errors.auxPhoneNumberPrefixFive}),
                                options: _ctx.formsSettings.valid_phone_number_prefix_options,
                                reduce: returnValue => returnValue.key,
                                "select-on-key-codes": [188, 13],
                                clearable: true,
                                modelValue: _ctx.auxPhoneNumberPrefixFive,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.auxPhoneNumberPrefixFive) = $event))
                              }, {
                                "no-options": _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                                ]),
                                _: 1
                              }, 8, ["class", "options", "reduce", "modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label", "yup-errors-variable"])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_v_form_group_input_text, {
                            value: _ctx.auxPhoneNumberFive,
                            label: _ctx.$t('Teléfono'),
                            class: "mb-24",
                            "yup-errors-variable": _ctx.errors.auxPhoneNumberFive,
                            autocomplete: "off",
                            "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => (_ctx.auxPhoneNumberFive = $event))
                          }, null, 8, ["value", "label", "yup-errors-variable"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
        ]),
        _: 1
      }),
      _createVNode(_component_modal_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_button, {
            variant: "link-secondary",
            class: "me-24",
            "aria-label": this.$t('Cancelar'),
            "data-bs-dismiss": "modal"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Cancelar')), 1)
            ]),
            _: 1
          }, 8, ["aria-label"]),
          _createVNode(_component_v_button, {
            variant: "secondary",
            class: "btn-icon",
            "aria-label": _ctx.$t('Actualizar'),
            disabled: !_ctx.meta.valid || _ctx.accepted,
            onClick: _ctx.updatePatient,
            "is-loading": _ctx.accepted
          }, {
            default: _withCtx(() => [
              _hoisted_31,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Actualizar')), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "disabled", "onClick", "is-loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}